import React, { useEffect } from 'react';
import { TextBox } from '@progress/kendo-react-inputs';
import "./style.css";

const TextFieldBox = React.memo(({ title, value, onChange, errorMessage , isRequired }) => {
    return (
        <div className="poll_and_survey_main_box margin-bottom">
            <div className="poll_and_survey_main_box_title">{title} {isRequired ? (<span style={{ color: "red" }}>*</span>) :  '' } </div>
            <div>
                <TextBox
                    className="poll_and_survey_main_box_field"
                    value={value}
                    onChange={onChange}
                />
                {errorMessage && (
                    <div className="poll_and_survey_error_text">{errorMessage}</div>
                )}
            </div>
        </div>
    );
});

export default TextFieldBox;
